<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div>
      <span class="action-name"> {{ action }} </span
      ><span class="records"> ({{ totalRecords || 0 }} records found)</span>
    </div>
    <div class="input-wrapper">
      <app-console-search
        [findOptions]="findOptions"
        [showDateRange]="showDateRange"
        [headercount]="headercount"
        [showHideHeaderColumnCount]="true"
        (clearSearchBoxEvent)="clearSearchBox()"
        (applyFilterByFieldEvent)="applyFilterByField($event)"
        (showHideColumnsEvent)="showHideColumns()"
        (clearFilterEvent)="clearFilter()"
      >
      </app-console-search>
    </div>
    <p-table
      [columns]="cols"
      [value]="liveStatusList"
      [lazy]="true"
      [scrollHeight]="innerHeight + 'vh'"
      (onLazyLoad)="loadLiveStatuses($event)"
      dataKey="id"
      [tableStyle]="{ 'min-width': '50rem' }"
      [paginator]="true"
      [rows]="10"
      [totalRecords]="totalRecords"
      [loading]="loading"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      [scrollable]="true"
      [style]="{ width: '100%' }"
      [(first)]="first"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="!col?.hide">
              {{ col.label }}
              <span class="fts">
                <span class="filter" *ngIf="col.showFilter" (click)="toggleCustomColumnFilter(col.name)">
                  <ng-container *ngIf="hasActiveFilter(col.name); else notSelected">
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                  </ng-container>
                  <ng-template #notSelected>
                    <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                  </ng-template>
                </span>
                <span class="sort" (click)="sortByColumn(col.name)">
                  <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                    <ng-container *ngIf="col.isAsc; else falseBlock">
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                    </ng-container>
                    <ng-template #falseBlock>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                    </ng-template>
                  </ng-container>
                  <ng-template #others>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                  </ng-template>
                </span>
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              {{ col.type === 'Date' || col.type === 'date' ? (rowData[col.name] | custdate) : rowData[col.name] }}
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">No Data Available</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
